
<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12">
              <h1>
                Основная информация
              </h1>
            </v-col>
            <v-col cols="12">
              <h3>
                Номер: {{ form.number }}
              </h3>
            </v-col>
            <v-col cols="12">
              <h3>
                Автор: {{ form.creator.name }} {{ form.creator.surname }}
              </h3>
            </v-col>
            <v-col cols="12">
              <h3>
                Ответственный: {{ form.creator.name }} {{ form.creator.surname }}
              </h3>
            </v-col>
            <v-col cols="12">
              <h3>
                Статус: {{ productMovementStatuses.find(f=>f.value==form.status).text }}
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <!--            <v-col cols="12">-->
            <!--              <h3>-->
            <!--                Основная информация-->
            <!--              </h3>-->
            <!--            </v-col>-->
            <v-col cols="12">
              <v-radio-group
                v-model="form.type"
                row
                label="Тип операции:"
              >
                <v-radio
                  :value="0"
                  label="Перемещение"
                />
                <v-radio
                  :value="1"
                  label="Списание"
                />
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.senderPointId"
                :items="points"
                label="Со склада"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.receiverPointId"
                :items="points"
                label="На склад"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-select
                v-model="form.movementReason"
                :items="movementReasons"
                label="Причина"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="form.comment"
                label="Комментарий"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                color="primary"
                outlined
                large
                min-width="100"
                class="mr-5"
                @click="() => onShowChooseNomenclatureDialog()"
              >
                Добавить
              </v-btn>
            </v-col>
            <v-col cols="12">
              <div
                style="display: flex; flex-direction: row; cursor: pointer;"
                class="ml-2 mb-3"
                @click="onDeleteSelectedNomenclatures()"
              >
                <div>
                  <v-icon
                    medium
                    color="#aaaaaa"
                    class="mr-1"
                  >
                    mdi-delete
                  </v-icon>
                </div>
                <div style="color: #aaaaaa">
                  Убрать выбранные из таблицы
                </div>
              </div>
              <v-data-table
                v-model="selectedNomenclatures"
                :items-per-page="10"
                dense
                :items="form.items"
                :headers="[
                  {sortable: false, value: 'delete', text: 'Убрать'},
                  {value: 'code', text: 'Артикул'},
                  {value: 'name', text: 'Название'},
                  // {text: 'Тип', value: 'type'},
                  {text: 'Ставка НДС', value: 'tax'},
                  {value: 'price', text: 'Цена'},
                  {value: 'quantity', text: 'Количество'},
                  // {value: 'category', text: 'Категория'},
                  // {value: 'subcategory', text: 'Подкатегория'},
                  // {value: 'subsubcategory', text: 'Подподкатегория'},
                ]"
                :footer-props="datatable_footer"
                no-data-text="Нет данных для отображения"
                show-select
              >
                <template v-slot:item.quantity="{item}">
                  <v-text-field
                    v-model="item.quantity"
                    type="number"
                    label="Количество"
                  />
                </template>
                <template v-slot:item.delete="{ item }">
                  <v-icon
                    color="#aaaaaa"
                    class="mr-2"
                    style="cursor: pointer;"
                    @click="onDeleteNomenclature(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
                  {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                </template>
              </v-data-table>
            </v-col>
            <v-col>
              Итого: {{ totalPosition }} позиции Общая сумма: {{ totalAmount }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="d-flex justify-center">
            <v-col
              v-if="form.status!==1 && !view"
              cols="12"
              sm="2"
            >
              <v-btn
                color="primary"
                block
                @click="onSave"
              >
                Сохранить
              </v-btn>
            </v-col>
            <v-col
              v-if="form.status!==1 && !view && !create"
              cols="12"
              sm="2"
            >
              <v-btn
                color="info"
                outlined
                block
                @click="onConduct"
              >
                Провести
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="3"
            >
              <v-btn
                block
                color="info"
                outlined
              >
                Запустить на согласование
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                block
                color="info"
                outlined
              >
                Печать
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                block
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialog.nomenclature.show"
      persistent
      max-width="80%"
    >
      <v-card>
        <v-card-title>Выберите номенклатуры</v-card-title>
        <v-card-text>
          <div>
            <v-data-table
              v-model="dialog.nomenclature.data"
              :items-per-page="10"
              dense
              :items="select.nomenclature"
              :headers="[
                {value: 'name', text: 'Название'},
                {value: 'code', text: 'Артикул'},
                {value: 'price', text: 'Цена'},
                // {value: 'category', text: 'Категория'},
                // {value: 'subcategory', text: 'Подкатегория'},
                // {value: 'subsubcategory', text: 'Подподкатегория'},
              ]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              show-select
            >
              <!--              <template v-slot:item.category="{item}">-->
              <!--                <div>-->
              <!--                  <div v-if="item.category && dict.categories[item.category]">-->
              <!--                    {{ dict.categories[item.category] }}-->
              <!--                  </div>-->
              <!--                  <div v-else>-->
              <!--                    <span style="color: #EEEEEE">нет</span>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-slot:item.subcategory="{item}">-->
              <!--                <div>-->
              <!--                  <div v-if="item.subcategory && dict.categories[item.subcategory]">-->
              <!--                    {{ dict.categories[item.subcategory] }}-->
              <!--                  </div>-->
              <!--                  <div v-else>-->
              <!--                    <span style="color: #EEEEEE">нет</span>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-slot:item.subsubcategory="{item}">-->
              <!--                <div>-->
              <!--                  <div v-if="item.subsubcategory && dict.categories[item.subsubcategory]">-->
              <!--                    {{ dict.categories[item.subsubcategory] }}-->
              <!--                  </div>-->
              <!--                  <div v-else>-->
              <!--                    <span style="color: #EEEEEE">нет</span>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">-->
              <!--                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}-->
              <!--              </template>-->
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <div
            class="mx-5"
            style="width: 100%"
          >
            <v-row class="justify-center">
              <v-col
                cols="6"
              >
                <v-btn
                  color="primary"
                  outlined
                  large
                  min-width="100"
                  @click="onCloseNomenclatureDialog()"
                >
                  <span class="mx-3">Закрыть</span>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                class="d-flex justify-end"
              >
                <v-btn
                  color="primary"
                  large
                  min-width="200"
                  @click="onAddNomenclature()"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script >
import { JustpayProductMovementService } from "@/views/loyalty/shared/services/justpay-productmovement-service"
import { movementReasonArray } from "@/views/loyalty/models/justpay-product-movement.model"

export default {
  name: 'ProductMovementForm',
  props: ['create', 'change', 'view', 'show', 'item'],
  data: () => ({
    clients: [],
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialog: {
      nomenclature: {
        show: false,
        data: [],
        page: {}
      }
    },
    dialogNomenclatureShow: false,
    form: {
      creator: { name: '', surname: '' },
      comment: '',
      items: [],
      number: 0,
      receiverPointId: null,
      responsible: { name: '', surname: '' },
      senderPointId: null,
      status: 0,
      type: 0,
      movementReason: 0
    },
    justpayProductMovementService: null,
    nomenclatures: [],
    points: [],
    productMovementStatuses: [
      { text: 'Новый', value: 0 },
      { text: 'Проведён', value: 1 },
      { text: 'Отменён', value: 2 }
    ],
    select: {
      nomenclature: []
    },
    selectedNomenclatures: [],
    movementReasons: [...movementReasonArray]
  }),
  computed: {
    totalPosition () {
      return this.form.items.length
    },
    totalAmount () {
      return this.form.items.reduce((acc, item) => acc + item.price * item.quantity, 0)
    }
  },
  beforeMount () {
    this.justpayProductMovementService = new JustpayProductMovementService()
  },
  async mounted () {
    let response = {}
    const productMovementId = this.$route.query.id
    response = await this.justpayProductMovementService.getProductMovement(productMovementId)
    if (productMovementId) {
      console.log('response', response)
      this.form = response.data
    }
    this.clients = response.clients
    this.nomenclatures = response.nomenclatures
    this.points = response.points
    this.select.nomenclature = JSON.parse(JSON.stringify(response.nomenclatures))
  },
  methods: {
    onAddNomenclature () {
      const previously_selected_nomenclatures_id = this.form.items.map(a => a.id)
      this.form.items.push(
          ...this.dialog.nomenclature.data.filter(
              a => (
                  !previously_selected_nomenclatures_id.includes(a.id)
              )
          ).map(a => Object.assign({}, a))
      )
      this.dialog.nomenclature.page = {}
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = false
    },
    onCloseNomenclatureDialog () {
      this.dialog.nomenclature.page = {}
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = false
    },
    onDeleteNomenclature (item) {
      console.log("onDeleteNomenclature")
      this.form.items = this.form.items.filter(a => a.id !== item.id)
    },
    onDeleteSelectedNomenclatures () {
      console.log("onDeleteSelectedNomenclatures")
      const selected_nomenclatures_id = this.selectedNomenclatures.map(a => a.id)
      this.form.items = this.form.items.filter(a => !selected_nomenclatures_id.includes(a.id))
      this.selectedNomenclatures = []
    },
    async onConduct () {
      if (this.form.id) {
        await this.justpayProductMovementService.conductProductMovement(this.form)
      }
      this.$router.go(-1)
    },
    async onSave () {
      if (this.form.id) {
        await this.justpayProductMovementService.changeProductMovement(this.form)
      } else {
        await this.justpayProductMovementService.createProductMovement(this.form)
      }
      this.$router.go(-1)
    },
    onShowChooseNomenclatureDialog () {
      this.dialog.nomenclature.show = true
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = true
    }
  }

}
</script>
<style scoped>

</style>
